import Highcharts from 'highcharts';
import ExportingModule from 'highcharts/modules/exporting';
import StockModule from 'highcharts/modules/stock';

ExportingModule(Highcharts);
StockModule(Highcharts);

Highcharts.setOptions({
  exporting: {
    enabled: false
  }
});

export default Highcharts;
